import { createContext } from "react";

const defaultActivePopupContext = {}

export const ActivePopupContext = createContext(defaultActivePopupContext)
const ActivePopupContextProvider = ActivePopupContext.Provider

export default ActivePopupContextProvider